import React from "react";
import * as linkify from "linkifyjs";
// import { Link } from 'react-router-dom';
import "./styles.scss";
// @ts-ignore
import plugin from "linkifyjs/plugins/mention";
import Linkify from "linkifyjs/react";
import linkifyHtml from 'linkifyjs/html';
import { IComment } from "../../../../../@types/IComment";
import { filterTimeStamp } from "../../../../../api/helper";
import LinkPreview from "../../../PostsList/Post/PostBody/LinkPreview";
import PostAttachments from "../../../PostsList/Post/PostBody/PostAttachments";
import UserTag from "../../UserTag";
import { replaceAtMentionsWithLinks } from '../../../../../helper/helper'
plugin(linkify);
const CommentItem = (props: { item: IComment }) => {
  const { item } = props;
    return (
    <div className="comment media">
      <UserTag user={item.author} noUsername className="mr-2" />
      <div className="media-body d-flex flex-column">
        <div className="d-flex flex-grow-1 align-items-center justify-content-between">
          <UserTag user={item.author} noProfilePicture className="mr-2" />
          <span className="my-2">{filterTimeStamp(item.created_at)}</span>
        </div>
        {item.text ? (
          <div className="d-flex flex-grow-1 mb-1 comment-txt">
            <div dangerouslySetInnerHTML={{__html: replaceAtMentionsWithLinks(item.text) }} />
          </div>
        ) : null}
        {item.link_preview ? (
          <div className="d-flex flex-grow-1 mb-1">
            <UserTag user={item.author} className="mr-2 invisibie" />
            <LinkPreview link_preview={item.link_preview} />
          </div>
        ) : null}
        {item.attachments.length ? (
          <div className="attachments flex-grow-1 mb-1">
            <PostAttachments
              post={item}
              attachments={item.attachments}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

interface Props {
  comments?: IComment[];
}

export default (props: Props) => {
  return (
    <div className="comments-list">
      {props.comments?.map((comment,id) => (
        <CommentItem key={id} item={comment} />
      ))}
    </div>
  );
};
